import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/ciwindow';

const namespace = 'APPRAISAL';

export const GET_PROPERTY_SEARCH_DATA_START = `${namespace}/GET_PROPERTY_SEARCH_DATA_START`;
export const GET_PROPERTY_SEARCH_DATA_SUCCESS = `${namespace}/GET_PROPERTY_SEARCH_DATA_SUCCESS`;
export const GET_PROPERTY_SEARCH_DATA_ERROR = `${namespace}/GET_PROPERTY_SEARCH_DATA_ERROR`;

export const GET_APPRAISAL_SEARCH_DATA_START = `${namespace}/GET_APPRAISAL_SEARCH_DATA_START`;
export const GET_APPRAISAL_SEARCH_DATA_SUCCESS = `${namespace}/GET_APPRAISAL_SEARCH_DATA_SUCCESS`;
export const GET_APPRAISAL_SEARCH_DATA_ERROR = `${namespace}/GET_APPRAISAL_SEARCH_DATA_ERROR`;

export const GET_POPUP_CONTENT_START = `${namespace}/GET_POPUP_CONTENT_START`;
export const GET_POPUP_CONTENT_SUCCESS = `${namespace}/GET_POPUP_CONTENT_SUCCESS`;
export const GET_POPUP_CONTENT_ERROR = `${namespace}/GET_POPUP_CONTENT_ERROR`;

export const GET_PROPERTY_MAP_CONFIGS_START = `${namespace}/GET_PROPERTY_MAP_CONFIGS_START`;
export const GET_PROPERTY_MAP_CONFIGS_SUCCESS = `${namespace}/GET_PROPERTY_MAP_CONFIGS_SUCCESS`;
export const GET_PROPERTY_MAP_CONFIGS_ERROR = `${namespace}/GET_PROPERTY_MAP_CONFIGS_ERROR`;

export const INSERT_PROPERTY_MAP_CONFIG_START = `${namespace}/INSERT_PROPERTY_MAP_CONFIG_START`;
export const INSERT_PROPERTY_MAP_CONFIG_SUCCESS = `${namespace}/INSERT_PROPERTY_MAP_CONFIG_SUCCESS`;
export const INSERT_PROPERTY_MAP_CONFIG_ERROR = `${namespace}/INSERT_PROPERTY_MAP_CONFIG_ERROR`;

export const UPDATE_PROPERTY_MAP_CONFIG_START = `${namespace}/UPDATE_PROPERTY_MAP_CONFIG_START`;
export const UPDATE_PROPERTY_MAP_CONFIG_SUCCESS = `${namespace}/UPDATE_PROPERTY_MAP_CONFIG_SUCCESS`;
export const UPDATE_PROPERTY_MAP_CONFIG_ERROR = `${namespace}/UPDATE_PROPERTY_MAP_CONFIG_ERROR`;

export const DELETE_PROPERTY_MAP_CONFIG_START = `${namespace}/DELETE_PROPERTY_MAP_CONFIG_START`;
export const DELETE_PROPERTY_MAP_CONFIG_SUCCESS = `${namespace}/DELETE_PROPERTY_MAP_CONFIG_SUCCESS`;
export const DELETE_PROPERTY_MAP_CONFIG_ERROR = `${namespace}/DELETE_PROPERTY_MAP_CONFIG_ERROR`;

export const SET_MAPDATA = `${namespace}/SET_MAPDATA`;

export const RESET_MAPDATA = `${namespace}/RESET_MAPDATA`;

export const SET_MAPCOORDS = `${namespace}/SET_MAPCOORDS`;

export const getPropertySearchData = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_PROPERTY_SEARCH_DATA_START,
  GET_PROPERTY_SEARCH_DATA_SUCCESS,
  GET_PROPERTY_SEARCH_DATA_ERROR,
);

export const getPropertyMapConfigs = makeApiActionCreatorV3(
  api.getPropertyMapConfigs,
  GET_PROPERTY_MAP_CONFIGS_START,
  GET_PROPERTY_MAP_CONFIGS_SUCCESS,
  GET_PROPERTY_MAP_CONFIGS_ERROR,
);

export const insertPropertyMapConfig = makeApiActionCreatorV3(
  api.insertPropertyMapConfig,
  INSERT_PROPERTY_MAP_CONFIG_START,
  INSERT_PROPERTY_MAP_CONFIG_SUCCESS,
  INSERT_PROPERTY_MAP_CONFIG_ERROR,
);

export const updatePropertyMapConfig = makeApiActionCreatorV3(
  api.updatePropertyMapConfig,
  UPDATE_PROPERTY_MAP_CONFIG_START,
  UPDATE_PROPERTY_MAP_CONFIG_SUCCESS,
  UPDATE_PROPERTY_MAP_CONFIG_ERROR,
);

export const deletePropertyMapConfig = makeApiActionCreatorV3(
  api.deletePropertyMapConfig,
  DELETE_PROPERTY_MAP_CONFIG_START,
  DELETE_PROPERTY_MAP_CONFIG_SUCCESS,
  DELETE_PROPERTY_MAP_CONFIG_ERROR,
);

export const getAppraisalSearchData = makeApiActionCreatorV3(
  api.getAppraisalSearchData,
  GET_APPRAISAL_SEARCH_DATA_START,
  GET_APPRAISAL_SEARCH_DATA_SUCCESS,
  GET_APPRAISAL_SEARCH_DATA_ERROR,
);

export const getPopupContent = makeApiActionCreatorV3(
  api.getPropertySearchData,
  GET_POPUP_CONTENT_START,
  GET_POPUP_CONTENT_SUCCESS,
  GET_POPUP_CONTENT_ERROR,
);

export function setMapData(data) {
  return async dispatch => {
    dispatch({ type: SET_MAPDATA, windowData: data });
  };
}

export function resetMapData() {
  return async dispatch => {
    dispatch({ type: RESET_MAPDATA });
  };
}

export function setMapCoords(data) {
  return async dispatch => {
    dispatch({ type: SET_MAPCOORDS, windowData: data });
  };
}
